import React from 'react';
import { Container } from 'react-bootstrap';

export default function SprintOutcomes({ title, items, colsClass = '' }) {
    return (
        <section className="sprint-outcomes">
            <Container>
                <div className="sprint-outcomes-header sprint-reveal">
                    <h2>{title}</h2>
                </div>
                
                <div className={`sprint-outcomes-grid ${colsClass}`}>
                    {items && items.map((item, idx) => (
                        <div className={`sprint-outcome-item sprint-reveal sprint-delay-${(idx % 6) + 1}`} key={idx}>
                            <div className="outcome-icon">{item.icon}</div>
                            <h4>{item.label}</h4>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
